import { render, staticRenderFns } from "./list-item-file.vue?vue&type=template&id=680ac4e7"
import script from "./list-item-file.vue?vue&type=script&lang=js"
export * from "./list-item-file.vue?vue&type=script&lang=js"
import style0 from "./list-item-file.vue?vue&type=style&index=0&id=680ac4e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports